import { FieldValues, Path, useFormContext } from "react-hook-form";
import { Sidebar } from "primereact/sidebar";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { DropdownFilterEvent } from "primereact/dropdown";

import DropdownControl from "@shared/ui/hook-form/dropdown-control/dropdown-control";
import { useFormDropdownPenaltyScheduleContext } from "./form-dropdown-penalty-schedule.context";

export interface FormDropdownPenaltyScheduleProps<T extends FieldValues> {
  name: Path<T>;
  allowCreate?: boolean;
}

export function FormDropdownPenaltySchedule<T extends FieldValues>({
  name,
  allowCreate = false,
}: FormDropdownPenaltyScheduleProps<T>) {
  const hintText = allowCreate
    ? `Select from the created holidayType dropdown. Otherwise, hit ENTER to create a new holidayType. If the holidayType doesn't exist select N/A`
    : "";
  const { control } = useFormContext<T>();
  const {
    sidebar,
    newPenaltySchedule,
    mappedPenaltySchedule,
    isCreating,
    setSidebar,
    setFilter,
    setNewPenaltySchedule,
    handleFilterInput,
    handleAdd,
  } = useFormDropdownPenaltyScheduleContext();
  
  return (
    <div className="penalty-schedule">
      {newPenaltySchedule && (
        <Sidebar visible={sidebar} onHide={() => setSidebar(false)}>
          <h2>Create new penaltySchedule</h2>
          <p>
            You are creating a new penaltySchedule. Please, fill the fields to create a
            new penaltySchedule and apply to current item creation.
          </p>
          <div className="flex flex-col gap-2 mt-4">
            <InputText
              placeholder="PenaltySchedule Name"
              value={newPenaltySchedule.name}
              onChange={(e: any) =>
                setNewPenaltySchedule({ ...newPenaltySchedule, name: e.target.value })
              }
            />
            <InputText
              placeholder="PenaltySchedule Description"
              value={newPenaltySchedule.description}
              onChange={(e: any) =>
                setNewPenaltySchedule({ ...newPenaltySchedule, description: e.target.value })
              }
            />

            <Button
              label="Create"
              onClick={handleAdd}
              className="block"
              disabled={isCreating}
            />
          </div>
        </Sidebar>
      )}
      <DropdownControl<T>
        control={control}
        name={name}
        label="PenaltySchedule"
        options={ mappedPenaltySchedule }
        containerClassName="mb-9"
        className="w-full md:w-3/4"
        placeholder="Enter your penaltySchedule"
        hint={hintText}
        filter
        onFilter={(e: DropdownFilterEvent) => setFilter(e.filter)}
        onKeyDown={allowCreate ? handleFilterInput : () => {}}
      />
    </div>
  );
}

export default FormDropdownPenaltySchedule;